import { render, staticRenderFns } from "./AddAreaDialog.vue?vue&type=template&id=0994789d&scoped=true"
import script from "./AddAreaDialog.vue?vue&type=script&lang=js"
export * from "./AddAreaDialog.vue?vue&type=script&lang=js"
import style0 from "./AddAreaDialog.vue?vue&type=style&index=0&id=0994789d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0994789d",
  null
  
)

export default component.exports